import { Component, Input } from '@angular/core';
import { AuditData, RoleAudit } from '../../../../../models/role-audit';
import { SecurityManagementService } from '../../../../../services/security-management.service';
import { SecurityWorkspaceService } from '../../../../../services/security-workspace.service';
import { HistoryService } from '../../../../../../admin/services/history.service';

@Component({
  selector: 'wre-role-history',
  templateUrl: './role-history.component.html',
  styleUrls: ['./role-history.component.sass']
})
export class RoleHistoryComponent {

  private _roleId: number;
  get roleId(): number {
    return this._roleId;
  }
  @Input() set roleId(value: number) {
    this._roleId = value;
    if (value != null) {
      this.getRoleAuditData();
    }
    this._historyService.assignDateValues();
  }

  roleAudit: RoleAudit;
  historyData = this._historyService.historyData;
  sortToggle = false;
  loading = true;
  errorMessage: boolean;
  errorMessageInfo: string;
  error: any;

  constructor(private securityService: SecurityManagementService, private securityWorkspaceService: SecurityWorkspaceService,
    private _historyService:HistoryService ) { }

  getRoleAuditData() {
    this.loading = true;
    this.securityService.getRoleAudit(this.roleId, this.securityWorkspaceService.currentWorkspace).then((res) => {
      if (res.status === 200) {
        this.roleAudit = res.body;
        this.setHistoryInfo();
        this.loading = false;
      } else {
        this.errorMessageInfo = 'An error has occured. Contact Administrator';
        this.errorMessage = true;
        this.loading = false;
      }
    }).catch(error => {
      this.error = error;
      console.error(error);
      this.errorMessageInfo = 'An error has occured. Contact Administrator';
      this.errorMessage = true;
      this.loading = false;
    });
  }

  setHistoryInfo(): void {
    this.sort(this.roleAudit.auditData);
     this._historyService.groupTimeStamp(this.roleAudit.auditData);
  }

  private sort(updateInfo: AuditData[]) {
    updateInfo.sort((a, b) => {
      return a.date > b.date ? -1 : 1;
    });
  }

  reverseHistoryData() {
    this._historyService.reverseHistoryData();
    this.sortToggle =!this.sortToggle;
  }

}
